import { render, staticRenderFns } from "./AddYoutubeVideo.vue?vue&type=template&id=69dc2206&scoped=true"
import script from "./AddYoutubeVideo.vue?vue&type=script&lang=js"
export * from "./AddYoutubeVideo.vue?vue&type=script&lang=js"
import style0 from "./AddYoutubeVideo.vue?vue&type=style&index=0&id=69dc2206&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69dc2206",
  null
  
)

export default component.exports